export default __webpack_public_path__ + "static/helium-b2abcb0452bb6cd2608e20bc8de11618.svg";